import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarHeading,
  ToolbarDescription,
  ToolbarActions,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { PageNavbar } from "@/pages/account";
import { useLayout } from "@/providers";
import { KeenIcon } from "@/components/keenicons";
import { YatchListing } from "./YatchListing";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";

const YachtManagement = () => {
  const { currentLayout } = useLayout();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  return (
    <Fragment>
      <PageNavbar />

      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="yatch-management-heading" />
              <ToolbarDescription>
                You can manage your club management here.
              </ToolbarDescription>
            </ToolbarHeading>
            <ToolbarActions>
              {hasPermission("club_management_create") && (
                <>
                  <button
                    type="button"
                    className="btn btn-sm btn-light"
                    onClick={() => navigate("/club-management/create")}
                    aria-label="Add new club"
                  >
                    Add New Club
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-light flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onClick={() => navigate("/club-registrations")}
                    aria-label="View registrations"
                  >
                    <KeenIcon
                      type="filled"
                      icon="notepad"
                      className="text-gray-500"
                    />
                    View Registrations
                  </button>
                </>
              )}
            </ToolbarActions>
          </Toolbar>

          <div className="mt-6">
            <YatchListing />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export { YachtManagement };
